import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTwitch: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconTwitch"><Path d="M13.5421 6.60715H12.0004V11.2143H13.5421V6.60715Z" fill="currentColor"/><Path d="M17.3962 11.2143V6.60715H15.8546V11.2143H17.3962Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M6.60417 2L2.75 5.83929V19.6607H7.375V23.5L11.2292 19.6607H14.3125L21.25 12.75V2H6.60417ZM16.6269 15.0536L19.7103 11.9821V3.53571H7.37693V15.0536H10.4603V18.125L13.5436 15.0536H16.6269Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTwitch;
